import React, {ChangeEvent, FC} from "react";

interface InputProps {
    label: string;
    type: string;
    value: string;
    onChange?: (value: string) => void;
    onChecked?: (value: boolean) => void;
}

const Input: FC<InputProps> = ({
                                   label,
                                   type,
                                   value,
                                   onChange,
                                   onChecked
                               }) => {
    const handleChange = (e: ChangeEvent) => {
        if (e.type === "checkbox") {
            onChecked && onChecked((e.target as HTMLInputElement).checked)
        } else {
            onChange && onChange((e.target as HTMLInputElement).value);
        }
    }
    return (
        <label>
            <span>{label}</span>
            <input type={type} value={value} onChange={handleChange}/>
        </label>
    );
};

export default Input;